import { createSlice } from '@reduxjs/toolkit';
import { fetchForYou } from '../thunks/trackThunks';

const initialState = {
    items: [],
    isForYouLoading: false,
    error: null,
};

const forYouSlice = createSlice({
    name: 'foryou',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
			.addCase(fetchForYou.pending, (state) => {
				state.isForYouLoading = true;
				state.error = null;
			})
			.addCase(fetchForYou.fulfilled, (state, action) => {
				state.isForYouLoading = false;
				state.items = action.payload;
			})
			.addCase(fetchForYou.rejected, (state, action) => {
				state.isForYouLoading = false;
				state.error = action.payload;
			});
    }
});

export default forYouSlice.reducer;